export default __webpack_public_path__ + "assets/img/ict-pan.741cbf945b2703f1ae766c6b7f8d98a3.svg";